export const MAX_LENGTH_DESCRIPTION_TEXT = 1000
export const MAX_LENGTH_FEEDBACK_TEXT = 400

export const DEFAULT_PRICE_CURRENCY = "EUR"
export const COPY_VARIANT_KEY_ICON_TIMEOUT = 3000

export const HEADER_HEIGHT_VARIABLE_NAME = "header-height"

export const GLOBAL_SEARCH_SHORTCUT_KEY = "k"

export const DEFAULT_TOAST_TIMEOUT = 5000
export const DEFAULT_TOAST_POSITION = "bottom-left"

export const ATTENTION_TOAST_TIMEOUT = 6000

export const DEFAULT_MAX_LENGTH = 240

export const DEFAULT_LOCALE = "de"

export const PROFILE_DELETE_CODE_LENGTH = 6
